<template>
  <a-card :bordered="false">
    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <a-row :gutter="24">
        </a-row>
      </a-form>
    </div>
    <!-- 查询区域-END -->

    <!-- 操作按钮区域 -->
<!--    <div class="table-operator">-->
<!--      <a-button @click="handleAdd" type="primary" icon="plus">{{$t('button.add')}}</a-button>-->
<!--      <a-button type="primary" icon="download" @click="handleExportXls('结算单')">{{$t('button.export')}}</a-button>-->
<!--      <a-upload name="file" :showUploadList="false" :multiple="false" :headers="tokenHeader" :action="importExcelUrl" @change="handleImportExcel">-->
<!--        <a-button type="primary" icon="import">{{$t('button.import')}}</a-button>-->
<!--      </a-upload>-->
<!--      <a-dropdown v-if="selectedRowKeys.length > 0">-->
<!--        <a-menu slot="overlay">-->
<!--          <a-menu-item key="1" @click="batchDel"><a-icon type="delete"/>{{$t('button.delete')}}</a-menu-item>-->
<!--        </a-menu>-->
<!--        <a-button style="margin-left: 8px"> {{$t('button.batchOperation')}} <a-icon type="down" /></a-button>-->
<!--      </a-dropdown>-->
<!--    </div>-->

    <!-- table区域-begin -->
    <div>

      <a-table
        ref="table"
        size="middle"
        bordered
        rowKey="id"
        class="j-table-force-nowrap"
        :scroll="{x:true}"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="ipagination"
        :loading="loading"
        :rowSelection="{selectedRowKeys: selectedRowKeys, onChange: onSelectChange}"
        @change="handleTableChange">

<!--        <template slot="htmlSlot" slot-scope="text">-->
<!--          <div v-html="text"></div>-->
<!--        </template>-->
<!--        <template slot="imgSlot" slot-scope="text">-->
<!--          <span v-if="!text" style="font-size: 12px;font-style: italic;">无图片</span>-->
<!--          <img v-else :src="getImgView(text)" height="25px" alt="" style="max-width:80px;font-size: 12px;font-style: italic;"/>-->
<!--        </template>-->
<!--        <template slot="fileSlot" slot-scope="text">-->
<!--          <span v-if="!text" style="font-size: 12px;font-style: italic;">无文件</span>-->
<!--          <a-button-->
<!--            v-else-->
<!--            :ghost="true"-->
<!--            type="primary"-->
<!--            icon="download"-->
<!--            size="small"-->
<!--            @click="downloadFile(text)">-->
<!--            下载-->
<!--          </a-button>-->
<!--        </template>-->
        <template v-for="(item, index) in columns" :slot="item.slotName">
          <span :key="index">{{ $t(item.slotName) }}</span>
        </template>

        <template :slot="item.dataIndex" slot-scope="text, record" v-for="item in columns">
          <mtc-lang-list-popover :key="item.dataIndex" :record="record" :item="item" :text="text" />
        </template>

        <span slot="action" slot-scope="text, record">
          <a @click="handleEdit(record)">{{$t('button.edit')}}</a>

          <a-divider type="vertical" />
          <a-dropdown>
            <a class="ant-dropdown-link">{{$t('button.more')}} <a-icon type="down" /></a>
            <a-menu slot="overlay">
              <a-menu-item>
                <a @click="handleDetail(record)">{{$t('button.details')}}</a>
              </a-menu-item>
               <a-menu-item>
                 <a-popconfirm :title="$t('tip.okToUpdateTheStatement')" @confirm="() => handleSettle(record.id)">
                  <a>{{$t('button.update')}}</a>
                </a-popconfirm>
              </a-menu-item>
              <a-menu-item>
                <a-popconfirm  :title="$t('tip.okToWithdraw')" @confirm="() => handleDelete(record.id)">
                  <a>{{$t('button.withdraw')}}</a>
                </a-popconfirm>
              </a-menu-item>
            </a-menu>
          </a-dropdown>
        </span>

      </a-table>
    </div>

    <efs-stl-settle-modal ref="modalForm" @ok="modalFormOk"/>
  </a-card>
</template>

<script>

  import { JeecgListMixin } from '@/mixins/JeecgListMixin'
  import EfsStlSettleModal from './modules/EfsStlSettleModal'
  import '@/assets/less/TableExpand.less'
  import { putAction } from '@api/manage'

  export default {
    name: "EfsStlSettleList",
    mixins:[JeecgListMixin],
    components: {
      EfsStlSettleModal
    },
    data () {
      return {
        description: '结算单管理页面',
        // 表头
        columns: [
          {
            title: '#',
            dataIndex: '',
            key:'rowIndex',
            width:60,
            align:"center",
            customRender:function (t,r,index) {
              return parseInt(index)+1;
            }
          },
          {
            slotName: 'tableHeader.partyA',
            scopedSlots: { title: 'tableHeader.partyA'},
            align:"center",
            dataIndex: 'paCompanyCode_dictText'
          },
          {
            slotName: 'tableHeader.partyB',
            scopedSlots: { title: 'tableHeader.partyB'},
            align:"center",
            dataIndex: 'pbFarmerCode_dictText'
          },
          {
            slotName: 'tableHeader.contractCode',
            scopedSlots: { title: 'tableHeader.contractCode'},
            align:"center",
            dataIndex: 'code'
          },
          {
            slotName: 'tableHeader.contractName',
            scopedSlots: { title: 'tableHeader.contractName'},
            align:"center",
            dataIndex: 'name'
          },
          {
            slotName: 'tableHeader.cooperationModel',
            scopedSlots: { title: 'tableHeader.cooperationModel'},
            align:"center",
            dataIndex: 'cooperMode_dictText'
          },
          {
            slotName: 'tableHeader.contractType',
            scopedSlots: { title: 'tableHeader.contractType'},
            align:"center",
            dataIndex: 'conType_dictText'
          },
          {
            slotName: 'tableHeader.feedingLot',
                        scopedSlots: { title: 'tableHeader.feedingLot'},
            align:"center",
            dataIndex: 'breedBatchCode'
          },
          {
            slotName: 'tableHeader.dateOfContractSigning',
            scopedSlots: { title: 'tableHeader.dateOfContractSigning'},
            align:"center",
            dataIndex: 'partyBSignDate',
            customRender:function (text) {
              return !text?"":(text.length>10?text.substr(0,10):text)
            }
          },
          {
            slotName: 'tableHeader.contractEffectiveDate',
            scopedSlots: { title: 'tableHeader.contractEffectiveDate'},
            align:"center",
            dataIndex: 'conStartDate',
            customRender:function (text) {
              return !text?"":(text.length>10?text.substr(0,10):text)
            }
          },
          {
            slotName: 'tableHeader.contractTerminationDate',
            scopedSlots: { title: 'tableHeader.contractTerminationDate'},
            align:"center",
            dataIndex: 'conEndDate',
            customRender:function (text) {
              return !text?"":(text.length>10?text.substr(0,10):text)
            }
          },
          {
            slotName: 'tableHeader.placeOfSigning',
            scopedSlots: { title: 'tableHeader.placeOfSigning'},
            align:"center",
            dataIndex: 'conAddress'
          },
          {
            slotName: 'tableHeader.industry',
            scopedSlots: { title: 'tableHeader.industry'},
            align:"center",
            dataIndex: 'conIndustry'
          },
          {
            slotName: 'tableHeader.sector',
            scopedSlots: { title: 'tableHeader.sector'},
            align:"center",
            dataIndex: 'conIndustryDepart'
          },
          {
            slotName: 'tableHeader.enteredBy',
            scopedSlots: { title: 'tableHeader.enteredBy'},
            align:"center",
            dataIndex: 'conReporter_dictText'
          },
          {
            slotName: 'tableHeader.currency',
            scopedSlots: { title: 'tableHeader.currency'},
            align:"center",
            dataIndex: 'conCurrency'
          },
          {
            slotName: 'tableHeader.localCurrency',
            scopedSlots: { title: 'tableHeader.localCurrency'},
            align:"center",
            dataIndex: 'conFunctionalCurrency'
          },
          {
            slotName: 'tableHeader.conversionRate',
            scopedSlots: { title: 'tableHeader.conversionRate'},
            align:"center",
            dataIndex: 'conDiscountRate'
          },
          {
            slotName: 'tableHeader.breederAdministrator',
            scopedSlots: { title: 'tableHeader.breederAdministrator'},
            align:"center",
            dataIndex: 'pbFarmerName_dictText'
          },
          {
            slotName: 'tableHeader.serviceGroup',
            scopedSlots: { title: 'tableHeader.serviceGroup'},
            align:"center",
            dataIndex: 'conServiceGroup_dictText'
          },
          {
            slotName: 'tableHeader.contractVersion',
            scopedSlots: { title: 'tableHeader.contractVersion'},
            align:"center",
            dataIndex: 'conVersion'
          },
          {
            slotName: 'tableHeader.operation',
            dataIndex: 'action',
            align:"center",
            fixed:"right",
            scopedSlots: { customRender: 'action', title: 'tableHeader.operation' }
          }
        ],
        url: {
          list: "/settleList/efsStlSettle/list",
          delete: "/settleList/efsStlSettle/delete",
          deleteBatch: "/settleList/efsStlSettle/deleteBatch",
          exportXlsUrl: "/settleList/efsStlSettle/exportXls",
          importExcelUrl: "settleList/efsStlSettle/importExcel",

        },
        dictOptions:{},
      }
    },
    created() {
    },
    computed: {
      importExcelUrl: function(){
        return `${window._CONFIG['domianURL']}/${this.url.importExcelUrl}`;
      }
    },
    methods: {
      initDictConfig(){
      },
      handleSettle(id){
        putAction('/settleList/efsStlSettle/updateEfsStlSettle', {"id": id, "approvalStatus": "60"}).then((res) => {
          if (res.success) {
            this.$message.success(res.message);
            this.loadData();
          } else {
            this.$message.error(res.message);
          }
        })
      },
    }
  }
</script>
<style scoped>
  @import '~@assets/less/common.less';
</style>